 import { motion, useInView } from "framer-motion";
import { useEffect, useState, useRef } from "react";

const Counter = ({ target, isPercent, isFixed, start }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let current = 0;
    const end = parseFloat(target);
    const duration = 1200;
    const frameRate = 16;
    const increment = end / (duration / frameRate);

    const counter = setInterval(() => {
      current += increment;
      if (current >= end) {
        clearInterval(counter);
        setCount(end);
      } else {
        setCount(current);
      }
    }, frameRate);

    return () => clearInterval(counter);
  }, [target, start]);

  return (
    <p className="text-4xl font-bold">
      {isFixed
        ? `${target}/7`
        : isPercent
          ? `${count.toFixed(1)}%`
          : `+${Math.floor(count).toLocaleString()}`}
    </p>
  );
};

const StatItem = ({ number, label, isPercent, isFixed, delay }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay }}
      className="flex flex-col items-center"
    >
      <Counter
        target={number}
        isPercent={isPercent}
        isFixed={isFixed}
        start={isInView}
      />
      <p className="text-sm mt-2 text-gray-200">{label}</p>
    </motion.div>
  );
};

export default function Stats() {
  const stats = [
    { number: 50000, label: "فاتورة يومية" },
    { number: 3000, label: "محل مسجل" },
    { number: 99.9, label: "نسبة رضا العملاء", isPercent: true },
    { number: 24, label: "دعم فني", isFixed: false, isPercent: false },
  ];

  return (
    <section className="py-20 px-6 bg-blue-900 text-white text-center">
      <div className="grid gap-8 md:grid-cols-4">
        {stats.map((item, idx) => (
          <StatItem
            key={idx}
            number={item.number}
            label={item.label}
            isPercent={item.isPercent}
            isFixed={item.isFixed}
            delay={idx * 0.2}
          />
        ))}
      </div>
    </section>
  );
}
